export const ADD_CONTACT_REQUESTED = 'contacts/ADD_CONTACT_REQUESTED';
export const ADD_CONTACT_SUCCESS = 'contacts/ADD_CONTACT_SUCCESS';
export const ADD_CONTACT_FAILURE = 'contacts/ADD_CONTACT_FAILURE';

export const DELETE_CONTACT_REQUESTED = 'contacts/DELETE_CONTACT_REQUESTED';
export const DELETE_CONTACT_SUCCESS = 'contacts/DELETE_CONTACT_SUCCESS';
export const DELETE_CONTACT_FAILURE = 'contacts/DELETE_CONTACT_FAILURE';

export const FETCH_CONTACTS_REQUESTED = 'contacts/FETCH_CONTACTS_REQUESTED';
export const FETCH_CONTACTS_SUCCESS = 'contacts/FETCH_CONTACTS_SUCCESS';
export const FETCH_CONTACTS_FAILURE = 'contacts/FETCH_CONTACTS_FAILURE';

// ADD FROM Facebook
export const ADD_FROM_FACEBOOK_REQUESTED = 'contacts/ADD_FROM_FACEBOOK_REQUESTED';
export const ADD_FROM_FACEBOOK_SUCCESS = 'contacts/ADD_FROM_FACEBOOK_SUCCESS';
export const ADD_FROM_FACEBOOK_FAILURE = 'contacts/ADD_FROM_FACEBOOK_FAILURE';

// ADD FROM Twitter
export const ADD_FROM_TWITTER_REQUESTED = 'contacts/ADD_FROM_TWITTER_REQUESTED';
export const ADD_FROM_TWITTER_SUCCESS = 'contacts/ADD_FROM_TWITTER_SUCCESS';
export const ADD_FROM_TWITTER_FAILURE = 'contacts/ADD_FROM_TWITTER_FAILURE';